<template>
  <div id="about">
    <v-card>
      <v-system-bar></v-system-bar>

      <img id="about-image" src="./img/logo_contest_brochure_head.jpg" >
      <br>
      <div id="socialnet-sec" style="float: right;">
        <div class="share-network-list">
          <div id="social-text"> แชร์หน้านี้ลงใน Social Network</div>
            <ShareNetwork
              v-for="network in networks"
              :network="network.network"
              :key="network.network"
              :style="{backgroundColor: network.color}"
              :url="sharing.url"
              :title="sharing.title"
              :description="sharing.description"
              :quote="sharing.quote"
              :hashtags="sharing.hashtags"
              :twitterUser="sharing.twitterUser"
            >
            <i :class="network.icon"></i>
            <span>{{ network.name }}</span>
        </ShareNetwork>
        </div>
      </div>
      <br><hr><br>
      <div class="imgbox"> <br> <div id="head-thai"> <font color='red'>&lt;New&gt;</font> : <b>ผลการประกวดตราสัญลักษณ์โครงการ ชนะเลิศเป็นผลงานของ นายบำรุง อิศรกุล</b></div> <img src="../../assets/news/logo_contest_win.jpg" width="50%" height="50%" alt="SMART CITY INFRALAB"></div>
      <br><hr><br>
      <br>
      <div id="about-thai"> <font color="red" style="font-size:30px"><b>ประกวดตราสัญลักษณ์</b>:</font></div>
      <div id="about-thai"> <b>โครงการการพัฒนาศักยภาพพื้นที่เมืองและโครงสร้างพื้นฐานรองรับยุทธศาสตร์เมืองอัจฉริยะของเทศบาลนครสงขลา</b>  </div>
      <br>
      <div id="about-subhead"> คณะวิศวกรรมศาสตร์ มหาวิทยาลัยเทคโนโลยีราชมงคลศรีวิชัย วิทยาเขตสงขลา ขอเชิญเข้าร่วมประกวดตราสัญลักษณ์ <b>โครงการการพัฒนาศักยภาพพื้นที่เมืองและโครงสร้างพื้นฐานรองรับยุทธศาสตร์เมืองอัจฉริยะของเทศบาลนครสงขลา</b> ปี 2563 <font color="red">ชิงเงินรางวัล 5,000 บาท </font> พร้อมใบประกาศเกียรติบัตร</div>
      <br>
      <br><a href="/documents/pdf/logo-contest-detail.pdf" target="_blank"><v-btn x-large color="primary" >เอกสารรายละเอียด<br>การประกวดตราสัญลักษณ์ (PDF)</v-btn></a> <br>
      <br><a href="https://docs.google.com/forms/d/12XwbETglwcgHzDvKx5EgmkDfU-ml0-8G-VevFwdWG3o/edit?ts=5ef5ca77" target="_blank"><v-btn x-large color="success" >ปิดโครงการ ประกาศผู้ชนะเลิศได้รับรางวัลแล้ว</v-btn></a> <br>
      <br><a href="/documents/docx/002ใบสมัครเข้าร่วมประกวดตราสัญลักษณ์ rev 1.docx" target="_blank"><v-btn x-large color="warning" min-height="110">ปิดโครงการ ประกาศผู้ชนะเลิศได้รับรางวัลแล้ว</v-btn></a> <br><br>
      <div id="about-subhead"> <b>วัตถุประสงค์</b> :</div>
      <div id="about-content">1.	เพื่อใช้ประชาสัมพันธ์กิจกรรมต่าง ๆ ของโครงการการพัฒนาพื้นที่เมืองและโครงสร้างพื้นฐานรองรับยุทธศาสตร์เมืองอัจฉริยะของเทศบาลนครสงขลา     </div>
      <div id="about-content">2.	เพื่อสร้างอัตลักษณ์และเอกลักษณ์ ของโครงการการพัฒนาศักยภาพพื้นที่เมืองและโครงสร้างพื้นฐานรองรับยุทธศาสตร์เมืองอัจฉริยะของเทศบาลนครสงขลา          </div>
      <div id="about-content">3.	เพื่อกระตุ้นให้เกิดการมีส่วนร่วมในกิจกรรมของประชาชนชาวสงขลา และบุคคลในพื้นที่จังหวัดอื่น ๆ ทั่วไป           </div>
      <br>
      <div id="about-subhead"> <b>คุณสมบัติและเงื่อนไข</b> :</div>
      <div id="about-content">1.	ผู้มีสิทธิ์ส่งประกวดเป็นนักศึกษา  ประชาชนชาวจังหวัดสงขลา และบุคคลในพื้นที่จังหวัดอื่น ๆ ทั่วไป </div>
      <div id="about-content">2.	ผู้ที่ส่งเข้าประกวด จะต้องเป็นผู้มีความสามารถในการสร้างสรรค์ผลงานของตนเองไม่นำส่วนหนึ่งส่วนใดของตราสัญลักษณ์ (Logo) ที่มีลิขสิทธิ์อยู่แล้วมาใช้ในการสร้างสรรค์ผลงานออกแบบของตนเอง</div>
      <div id="about-content">3.	ผู้เข้าร่วมการประกวดสามารถส่งผลงานการออกแบบได้คนละไม่เกิน 2 ชิ้นงาน</div>
      <div id="about-content">4.	ผลงานที่ส่งประกวดจะต้องจัดทำหรือผลิตขึ้นใหม่ไม่เคยนำเข้าประกวดที่ใดมาก่อน </div>
      <div id="about-content">5.	ในกรณีที่ผู้ส่งผลงานเข้าประกวดเลียนแบบตราสัญลักษณ์ของผู้อื่น ไม่ว่าส่วนใดส่วนหนึ่งหรือมีการละเมิดลิขสิทธิ์     ผู้ส่งผลงานจะต้องรับผิดชอบทางกฎหมาย</div>
      <div id="about-content">6.	ผลงานที่ได้รับรางวัล หากพบภายหลังว่ามีการละเมิดลิขสิทธิ์ คณะกรรมการตัดสินจะตัดสิทธิ์การได้รางวัลของผลงานชิ้นนั้น ๆ โดยเจ้าของผลไม่สามารถฟ้องร้องได้ในทุกกรณี</div>
      <div id="about-content">7.	คณะวิศวกรรมศาสตร์ มหาวิทยาลัยเทคโนโลยีราชมงคลศรีวิชัย วิทยาเขตสงขลา มีสิทธิ์ในการปรับปรุงแบบผลงานที่ได้รางวัลให้มีความเหมาะสมกับการใช้งาน </div>
      <div id="about-content">8.	ผลการทุกชิ้นที่ส่งเข้าประกวด คณะวิศวกรรมศาสตร์ มหาวิทยาลัยเทคโนโลยีราชมงคลศรีวิชัย วิทยาเขตสงขลา     มีสิทธิ์ที่จะนำไปเผยแพร่ในสื่อต่าง ๆ ได้ </div>
      <div id="about-content">9.	ผลการพิจารณาและการตัดสินถือเป็นที่สิ้นสุดไม่สามารถนำไปฟ้องร้องหรือดำเนินคดีใด ๆ ได้ </div>
      <br>
      <div id="about-subhead"> <b>กำหนดระยะเวลา </b> :</div>
      <div id="about-content">เปิดรับผลงานตั้งแต่บัดนนี้จนถึง 10 กรกฎาคม 2563  </div>
      <div id="about-content">ประกาศผลการประกวดอย่างเป็นทางการในวันที่ 14 กรกฎาคม 2563</div>
      <div id="about-content">ทางเว็บไซต์ https://cityinfralab.rmutsv.ac.th/ และ เพจเฟซบุ๊ก <b>City infrastructure lab</b></div>
      <br>
      <div id="about-subhead"> <b>รางวัลการประกวด  </b> :</div>
      <div id="about-content">รางวัลชนะเลิศจำนวน 1 รางวัล เป็นเงินสด 5,000 บาท พร้อมใบประกาศเกียรติบัตร</div>
      <br>
      <div id="about-subhead"> <b>ติดต่อสอบถาม  </b> :</div>
      <div id="about-content">-	โครงการการพัฒนาศักยภาพพื้นที่เมืองและโครงสร้างพื้นฐานรองรับยุทธศาสตร์เมืองอัจฉริยะของเทศบาล   นครสงขลา สาขาวิศวกรรมโยธา คณะวิศวกรรมศาสตร์ มหาวิทยาลัยเทคโนโลยีราชมงคลศรีวิชัย วิทยาสงขลา  </div>
      <div id="about-content">-	โทรศัพท์ 062-2435571</div>
      <br>
      <div id="about-thai"> <b>รายละเอียดการประกวดตราสัญลักษณ์</b></div> 
      <div id="about-thai"> <b>โครงการการพัฒนาศักยภาพพื้นที่เมืองและโครงสร้างพื้นฐานรองรับยุทธศาสตร์เมืองอัจฉริยะของเทศบาลนครสงขลา</b> :</div>
      <br>
      <div id="about-subhead"> <b>1. หลักการและเหตุผล   </b> :</div>
      <div id="about-content">โครงการการพัฒนาศักยภาพพื้นที่เมืองและโครงสร้างพื้นฐานรองรับยุทธศาสตร์เมืองอัจฉริยะของเทศบาลนครสงขลา เป็นโครงการวิจัยที่จัดทำขึ้นเพื่อตั้งศูนย์พัฒนาเมืองและโครงสร้างพื้นฐานรองรับความร่วมมือของทุกภาคส่วน ทั้งหน่วยงานรัฐ เอกชน ชุมชน และภาควิชาการ เขตเทศบาลนครสงขลา จังหวัดสงขลา โดยทำการศึกษา วิเคราะห์พื้นที่ที่มีศักยภาพ วางแผนพัฒนาเมืองและโครงสร้างพื้นฐาน เพื่อส่งเสริมให้เป็นเมืองอัจฉริยะอย่างเป็นรูปอธรรมนำไปสู่การสร้างคุณภาพชีวิตที่ดีของประชากร </div>
      <div id="about-content">การจัดประกวดตราสัญลักษณ์เป็นกิจกรรมหนึ่งที่จัดทำขึ้นเพื่อประชาชนคนทั่วไปที่อาศัยอยู่ในจังหวัดสงขลา และจังหวัดอื่น ๆ ได้เข้าร่วมเป็นส่วนหนึ่งของโครงการการพัฒนาศักยภาพพื้นที่เมืองและโครงสร้างพื้นฐานรองรับยุทธศาสตร์เมืองอัจฉริยะของเทศบาลนครสงขลา โดยการให้มีส่วนร่วมในการคิดและลงมือเพื่อพัฒนาสงขลาให้เป็นเมืองน่าอยู่ จึงจัดโครงการประกวดตราสัญลักษณ์ขึ้น   </div>
      <div id="about-subhead"> <b>2. วัตถุประสงค์   </b> :</div>
      <div id="about-content">2.1  เพื่อใช้ประชาสัมพันธ์กิจกรรมต่าง ๆ ของโครงการการพัฒนาศักยภาพพื้นที่เมืองและโครงสร้างพื้นฐานรองรับยุทธศาสตร์เมืองอัจฉริยะของเทศบาลนครสงขลา     </div>
      <div id="about-content">2.2 เพื่อสร้างอัตลักษณ์และเอกลักษณ์ ของโครงการการพัฒนาศักยภาพพื้นที่เมืองและโครงสร้างพื้นฐานรองรับยุทธศาสตร์เมืองอัจฉริยะของเทศบาลนครสงขลา    </div>
      <div id="about-content">2.3  เพื่อกระตุ้นให้เกิดการมีส่วนร่วมในกิจกรรมของประชาชนชาวสงขลา และบุคคลในพื้นที่จังหวัดอื่น ๆ ทั่วไป </div>
      <div id="about-subhead"> <b>3. แนวคิดหลักในการออกแบบ</b> :</div>
      <div id="about-content">3.1 โครงการการพัฒนาศักยภาพพื้นที่เมืองและโครงสร้างพื้นฐานรองรับยุทธศาสตร์เมืองอัจฉริยะของเทศบาลนครสงขลา ประกอบด้วย 3 โครงการย่อย ดังต่อไปนี้ </div>
      <div id="about-sub-content">- โครงการย่อยที่ 1 การพัฒนาพื้นที่กิจกรรมสาธารณะเพื่อพัฒนาให้สอดคล้องกับเมืองอัจฉริยะสงขลา</div>
      <div id="about-sub-content">- โครงการย่อยที่ 2 ระบบเตือนภัยมลพิษทางอากาศสำหรับเทศบาลนครสงขลาเมืองอัจฉริยะ</div>
      <div id="about-sub-content">- โครงการย่อยที่ 3 ระบบจราจรอัจฉริยะสำหรับเมืองสงขลาน่าอยู่ </div>
      <div id="about-content">3.2 วิสัยทัศน์ </div>
      <div id="about-sub-content">โครงการการพัฒนาศักยภาพพื้นที่เมืองและโครงสร้างพื้นฐานรองรับยุทธศาสตร์เมืองอัจฉริยะของเทศบาลนครสงขลา เป็นทีมวิจัยที่ใช้นวัตกรรมสร้างสรรค์และพัฒนาให้สงขลาเป็นเมืองอัจฉริยะต้นแบบ  </div>
      <div id="about-content">3.3 พันธกิจ </div>
      <div id="about-sub-content">1. ผลิตผลงานวิจัยและสร้างนวัตกรรมเพื่อพัฒนาสงขลาเป็นเมืองอัจฉริยะ  </div>
      <div id="about-sub-content">2.บริการวิชาการเพื่องสร้างความเข้มแข็งและตอบสนองความต้องการของชุมชนและสังคม บนพื้นฐานสังคมพหุวัฒนธรรม  </div>
      <div id="about-subhead"> <b>4. คุณสมบัติและเงื่อนไข</b> :</div>
      <div id="about-content">4.1	ผู้มีสิทธิ์ส่งประกวดเป็นนักศึกษา  ประชาชนชาวจังหวัดสงขลา และบุคคลในพื้นที่จังหวัดอื่น ๆ ทั่วไป </div>
      <div id="about-content">4.2	ผู้ที่ส่งเข้าประกวด จะต้องเป็นผู้มีความสามารถในการสร้างสรรค์ผลงานของตนเองไม่นำส่วนหนึ่งส่วนใดของตราสัญลักษณ์ (Logo) ที่มีลิขสิทธิ์อยู่แล้วมาใช้ในการสร้างสรรค์ผลงานออกแบบของตนเอง</div>
      <div id="about-content">4.3 ผู้เข้าร่วมการประกวดสามารถส่งผลงานการออกแบบได้คนละไม่เกิน 2 ชิ้นงาน</div>
      <div id="about-content">4.4 ผลงานที่ส่งประกวดจะต้องจัดทำหรือผลิตขึ้นใหม่ไม่เคยนำเข้าประกวดที่ใดมาก่อน </div>
      <div id="about-content">4.5 ในกรณีที่ผู้ส่งผลงานเข้าประกวดเลียนแบบตราสัญลักษณ์ของผู้อื่น ไม่ว่าส่วนใดส่วนหนึ่งหรือมีการละเมิดลิขสิทธิ์ผู้ส่งผลงานจะต้องรับผิดชอบทางกฎหมาย</div>
      <div id="about-content">4.6 ผลงานที่ได้รับรางวัล หากพบภายหลังว่ามีการละเมิดลิขสิทธิ์ คณะกรรมการตัดสินจะตัดสิทธิ์การได้รางวัลของผลงานชิ้นนั้น ๆ โดยเจ้าของผลไม่สามารถฟ้องร้องได้ในทุกกรณี</div>
      <div id="about-content">4.7 คณะวิศวกรรมศาสตร์ มหาวิทยาลัยเทคโนโลยีราชมงคลศรีวิชัย วิทยาเขตสงขลา มีสิทธิ์ในการปรับปรุงแบบผลงานที่ได้รางวัลให้มีความเหมาะสมกับการใช้งาน </div>
      <div id="about-content">4.8 ผลการทุกชิ้นที่ส่งเข้าประกวด คณะวิศวกรรมศาสตร์ มหาวิทยาลัยเทคโนโลยีราชมงคลศรีวิชัย วิทยาเขตสงขลา             มีสิทธิ์ที่จะนำไปเผยแพร่ในสื่อต่าง ๆ ได้ </div>
      <div id="about-content">4.9 ผลการพิจารณาและการตัดสินถือเป็นที่สิ้นสุดไม่สามารถนำไปฟ้องร้องหรือดำเนินคดีใด ๆ ได้</div>
      <div id="about-subhead"> <b>5. หลักเกณฑ์การส่งผลงานเข้าประกวด </b> :</div>
      <div id="about-content">5.1 ตราสัญลักษณ์ต้องสื่อความหมายของโครงการการพัฒนาศักยภาพพื้นที่เมืองและโครงสร้างพื้นฐานรองรับยุทธศาสตร์ เมืองอัจฉริยะ ของเทศบาลนครสงขลา </div>
      <div id="about-content">5.2 ไม่จำกัดเทคนิคในการสร้างผลงาน </div>
      <div id="about-content">5.3 ผลงานที่ส่งเข้าประกวดจะต้องมีขนาดไม่เกิน 30 × 30 เซนติเมตร และไม่เล็กกว่า 10 ×10 เซนติเมตร พร้อมทั้งย่อส่วนในขนาด 3 ×3 เซนติเมตร ทั้งแบบสีและขาวดำ จำนวน 1 ชิ้นต่อ 1 ผลงาน ในกระดาษขนาด A4  พร้อมคำอธิบายประกอบแบบตราสัญลักษณ์ในแผ่นเดียวกัน </div>
      <div id="about-content">5.4 ส่งผลงานผ่านอิเมล์ โดยบันทึกไฟล์ในนามสกุล tif ความละเอียด 1,200 DPI</div>
      <div id="about-subhead"> <b>6. การส่งผลงานเข้าประกวด  </b> :</div>
      <div id="about-content">6.1 สมัครเข้าร่วมประกวดออนไลน์ที่ <a href="https://docs.google.com/forms/d/12XwbETglwcgHzDvKx5EgmkDfU-ml0-8G-VevFwdWG3o/viewform" target="_blank">https://docs.google.com/forms/d/12XwbETglwcgHzDvKx5EgmkDfU-ml0-8G-VevFwdWG3o/viewform</a> <br> หรือ <a href="/documents/docx/002ใบสมัครเข้าร่วมประกวดตราสัญลักษณ์ rev 1.docx" target="_blank">ดาวน์โหลดใบสมัครได้ที่นี่ Link </a> จากนั้นกรอกข้อมูลในใบสมัครแล้วส่งไปที่ อีเมล์ cityinfralab@gmail.com หรือ เพจเฟซบุ๊ก City infrastructure lab  </div>
      <div id="about-content">6.2 ส่งผลงานผ่านช่องทางอีเมล์ cityinfralab@gmail.com  </div>
      <div id="about-content">6.3  ส่งผลงานภายในวันที่ 10 กรกฎาคม 2563 </div>
      <div id="about-subhead"> <b>7. การประกาศผลการประกวด   </b> :</div>
      <div id="about-content">คณะวิศวกรรมศาสตร์ มหาวิทยาลัยเทคโนโลยีราชมงคลศรีวิชัย จะประกาศผลการประกวดอย่างเป็นทางการในวันที่ 14 กรกฎาคม 2563 ทางเว็บไซต์ https://cityinfralab.rmutsv.ac.th/ และ เพจเฟซบุ๊ก City infrastructure lab</div>
      <div id="about-subhead"> <b>8. รางวัลการประกวด         </b> :</div>
      <div id="about-content">รางวัลชนะเลิศจำนวน 1 รางวัล เป็นเงินสด 5,000 บาท พร้อมใบประกาศเกียรติบัตร</div>

      <br><a href="/documents/pdf/logo-contest-detail.pdf" target="_blank"><v-btn x-large color="primary" >เอกสารรายละเอียด<br>การประกวดตราสัญลักษณ์ (PDF)</v-btn></a> <br>
      <br><a href="https://docs.google.com/forms/d/12XwbETglwcgHzDvKx5EgmkDfU-ml0-8G-VevFwdWG3o/edit?ts=5ef5ca77" target="_blank"><v-btn x-large color="success" >ปิดโครงการ ประกาศผู้ชนะเลิศได้รับรางวัลแล้ว</v-btn></a> <br>
      <br><a href="/documents/docx/002ใบสมัครเข้าร่วมประกวดตราสัญลักษณ์ rev 1.docx" target="_blank"><v-btn x-large color="warning" min-height="110">ปิดโครงการ ประกาศผู้ชนะเลิศได้รับรางวัลแล้ว</v-btn></a> <br><br>

      <br><a href="./news/logo-contest"><img id="full-image" src="../../assets/news/logo_contest_brochure.jpg"></a><br>
    </v-card>
  </div>
</template>>

<script>
  // Extensions
  import View from '@/views/View'

  function getMeta(metaName) {
  const metas = document.getElementsByTagName('meta');

  for (let i = 0; i < metas.length; i++) {
    if (metas[i].getAttribute('name') === metaName) {
      return metas[i].getAttribute('content');
    }
  }

  return '';
  }


  export default {
    name: 'About',
    metaInfo: { title: 'ขอเชิญส่งผลงานเข้าร่วมประกวดตราสัญลักษณ์ โครงการการพัฒนาศักยภาพพื้นที่เมืองและโครงสร้างพื้นฐานรองรับยุทธศาสตร์เมืองอัจฉริยะของเทศบาลนครสงขลา' },
    extends: View,
    props: {
      id: {
        type: String,
        default: 'about',
      },
    },
    data () {
      return {
          sharing: {
            url: window.location.href,
            title:  getMeta('title'),//'ขอเชิญส่งผลงานประกวดตราสัญลักษณ์ โครงการการพัฒนาศักยภาพพื้นที่เมืองและโครงสร้างพื้นฐานรองรับยุทธศาสตร์เมืองอัจฉริยะของเทศบาลนครสงขลา', //this.$route.meta.fields.title
            description: 'ขอเชิญส่งผลงานประกวดตราสัญลักษณ์ โครงการการพัฒนาศักยภาพพื้นที่เมืองและโครงสร้างพื้นฐานรองรับยุทธศาสตร์เมืองอัจฉริยะของเทศบาลนครสงขลา',
            quote: 'ขอเชิญส่งผลงานประกวดตราสัญลักษณ์ โครงการการพัฒนาศักยภาพพื้นที่เมืองและโครงสร้างพื้นฐานรองรับยุทธศาสตร์เมืองอัจฉริยะของเทศบาลนครสงขลา',
            hashtags: 'CityInfralab,RUTS,smartcity,ประกวดLOGO',
            twitterUser: 'CityInfralab'
          },
          networks: [
            { network: 'facebook', name: 'Facebook', icon: 'fab fah fa-lg fa-facebook-f', color: '#1877f2' },
            { network: 'line', name: 'Line', icon: 'fab fah fa-lg fa-line', color: '#00c300' },
            { network: 'twitter', name: 'Twitter', icon: 'fab fah fa-lg fa-twitter', color: '#1da1f2' },
          ]
        }
    }
  }
</script>

<style>
#head-thai {
  font-size:18pt;
  color: #043a20;
  text-align: center;
  padding-left: 10px;
}
#about-thai {
  font-size:18pt;
  color: #043a20;
  text-align: left;
  padding-left: 50px;
  padding-right: 50px;
}
#about-subhead {
  font-size:14pt;
  color: #043a20;
  text-align: left;
  padding-left: 50px;
  padding-right: 50px;
}
#about-content {
  font-size:11pt;
  text-align: left;
  padding-left: 50px;
  padding-right: 50px;
  text-indent: 50px;
}
#about-sub-content {
  font-size:11pt;
  text-align: left;
  padding-left: 100px;
  padding-right: 50px;
  text-indent: 50px;
}
#about-caption {
  font-size:11pt;
  font-weight: bold;
  text-align: center;
}
#about-image {
  display: block;
	object-fit: fill;
	width: 100%;
}
#full-image {
  display: block;
	object-fit: fill;
	width: 100%;
}
#social-text {
  font-size:12pt;
  color: #043a20;
  padding-right: 10px;
}
</style>
